/**
 *  NotFoundError custom error
 */

export default class NotFoundError extends Error {
  public constructor(message?: string) {
    if (!new.target) {
      throw new Error('NotFoundError() must be called with new');
    }

    super(message || 'NotFoundError error');

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, NotFoundError.prototype);

    this.name = 'NotFoundError';

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NotFoundError);
    }
  }
}
